export default "__VITE_PUBLIC_ASSET__3dc1f9b3__"